// src/pages/History/20thCentury/IndianIndependence.jsx
import React from 'react';
import TopicPage from '../../../components/TopicPageNew';
import bg from '../../../assets/history2/20th_Century_-_Indian_Independence.png';

function HistoryPageIndianIndependence() {
  return (
    <TopicPage
      topicKey="Indian Independence"
      title="History: Indian Independence"
      backgroundImage={bg}
      startRoute="/History-Indian-Independence-Go"
      scrollLabels={[
        "British Colonial Rule",
        "Gandhi and Nonviolent Resistance",
        "Partition and Independence",
      ]}
      backRoute="/history-20th-century"
      backLabel="← Return to topics"
      backButtonClassName="journey-button special"
      backButtonStyle={{ fontSize: '1.1rem', backgroundColor: '#553c0d' }}
    />
  );
}

export default HistoryPageIndianIndependence;
